<div lnClickOutSide (clickOutside)="closeDropdown()"
     [ngClass]="['relative h-[48px] rounded-md outline outline-1 outline-offset-[-0.50px] border border-cafe border-opacity-30 focus:outline-none]', preventChange() ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''
     ]"
     [style.width.px]="computedWidthInPixel()"
>
  <!-- Dropdown button -->
  <button
    type="button"
    (click)="toggleDropdown()"
    class=" flex w-full h-[48px]">
    <div class="flex flex-row w-full justify-between pl-[16px] pr-[11px] items-center">
      <div class="text-cafe text-base font-medium  pt-[13.5px] pb-[15.5px]">
        {{ selected() }}
      </div>
    <div class="transform transition-transform duration-200" [ngClass]="{ 'rotate-180': isOpen() }">
      <ln-chevron-down-svg-icon [class]="'h-[12px] w-[24px]'" fillColor = "#372121"></ln-chevron-down-svg-icon>
    </div>
    </div>
  </button>

  <!-- Dropdown menu -->
  @if(isOpen()) {
    <div class="absolute z-10 mt-1 w-full rounded-md border border-gray-300 bg-white shadow-lg">
      <ul class="text-cafe text-base font-medium">
        @for (option of options(); track option) {
          <li class="cursor-pointer w-full py-2 hover:bg-gray-100">
            <button class="w-full text-start pl-[16px]" (click)="selectOption(option)">
              {{ option }}
            </button>
          </li>
        }
      </ul>
    </div>
  }

</div>
